import { MagpieConnection } from 'magpie-lib/connection';
import { areTargetElementToRectsEqual, getSelectorsToElementRects } from '../utils/elementRectUtils';
import { targetElementRectsMessages } from './targetElementRects.messages';
import { targetElementRectsTopic } from './targetElementRects.topic';
import { Logger } from 'simple-logging-lib';
import { LOGGER_NAME } from '../logging/setupLogger';
export const maybeSendTargetElementRectsUpdate = previousTargetElementsToRects => () => {
  const logger = Logger.getLogger(LOGGER_NAME);
  const targetElementsToRects = getSelectorsToElementRects(Object.keys(previousTargetElementsToRects));
  if (areTargetElementToRectsEqual(previousTargetElementsToRects, targetElementsToRects)) {
    return;
  }
  const message = targetElementRectsMessages.sendTargetElementRects.create({
    targetElementsToRects
  });
  logger.debug('updating target element rects', targetElementsToRects);
  MagpieConnection.get().useTopic(targetElementRectsTopic).publish(message);
};